import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_PAYMENTS_LIST = gql`
query getCollatedPayments {
  getCollatedPayments {
    providerId
    providerResponse
  }
}
`;

const getCollatedPayments = async () => {
  try {
    const result = await client
      .query({
        query: GET_PAYMENTS_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { getCollatedPayments: getCollatedPaymentsData },
    } = result;

    if (getCollatedPaymentsData) {
      return getCollatedPaymentsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getCollatedPayments`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getCollatedPayments Error: ${error}`);
    return null;
  }
};

export default getCollatedPayments;
